export const Logo = ({ className = "", dark = false, onClick }) => {
  return (
    <button
      onClick={onClick}
      data-testid="brand-logo"
      className={`flex items-center gap-2.5 group ${className}`}
      aria-label="YıkaGel"
    >
      <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-[#1677FF] to-[#22C7D6] shadow-[0_6px_18px_-4px_rgba(22,119,255,0.5)] transition-transform group-hover:scale-105">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2.5c3.6 4.2 6.5 7.6 6.5 11.2A6.5 6.5 0 0 1 12 20.2a6.5 6.5 0 0 1-6.5-6.5C5.5 10.1 8.4 6.7 12 2.5Z" fill="white" fillOpacity="0.95"/>
          <path d="M9.5 13.6c0 1.6 1.1 2.7 2.6 2.7" stroke="#1677FF" strokeWidth="1.4" strokeLinecap="round"/>
        </svg>
      </span>
      <span className={`font-heading text-xl font-extrabold tracking-tight ${dark ? "text-white" : "text-[#172033]"}`}>
        Yıka<span className="text-[#1677FF]">Gel</span>
      </span>
    </button>
  );
};
